import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
    DvfField,
    dvfMaxMagnitude,
    dvfMeanMagnitude,
} from '~/domain/dvf/dvfField';
import { useDvfCursorProbe } from '~/hooks/viewer/useDvfCursorProbe';
import { asCm } from '~/utils/measurementFormat';
import { InfoRow } from './InfoRow';

export default function DeformationStatistics({
    field: dvf,
}: {
    field: DvfField;
}) {
    const cursor = useDvfCursorProbe(dvf);

    return (
        <Box sx={{ display: 'grid', rowGap: 0.5 }}>
            <Typography fontSize={11} fontWeight={600}>
                <FormattedMessage id="deformationField.statistics" />
            </Typography>
            <InfoRow labelId="deformationField.label.deformation">
                <FormattedMessage
                    id="deformationField.deformationValue"
                    values={{
                        max: asCm(dvfMaxMagnitude(dvf)),
                        mean: asCm(dvfMeanMagnitude(dvf)),
                    }}
                />
            </InfoRow>
            <InfoRow
                labelId="deformationField.label.crosshair"
                color={
                    cursor.status === 'inside'
                        ? 'text.primary'
                        : 'text.secondary'
                }
            >
                {cursor.status === 'outside' ? (
                    <FormattedMessage id="deformationField.probeOutside" />
                ) : cursor.status === 'inside' ? (
                    <FormattedMessage
                        id="deformationField.probeXyz"
                        values={{
                            x: asCm(cursor.probe.displacementMm[0]),
                            y: asCm(cursor.probe.displacementMm[1]),
                            z: asCm(cursor.probe.displacementMm[2]),
                        }}
                    />
                ) : (
                    <FormattedMessage id="deformationField.probeHint" />
                )}
            </InfoRow>
        </Box>
    );
}
